var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19067 5.62856C2.19067 3.49377 3.92126 1.76318 6.05606 1.76318C8.19085 1.76318 9.92144 3.49377 9.92144 5.62856C9.92144 6.69283 9.49231 7.65545 8.79586 8.35522C8.79364 8.35738 8.79144 8.35956 8.78924 8.36175C8.78705 8.36395 8.78487 8.36615 8.78271 8.36837C8.08294 9.06482 7.12032 9.49395 6.05606 9.49395C3.92126 9.49395 2.19067 7.76336 2.19067 5.62856ZM9.34401 9.97718C9.30876 9.94193 9.253 9.93811 9.2127 9.96746C8.32715 10.6126 7.23568 10.9939 6.05606 10.9939C3.09284 10.9939 0.690674 8.59178 0.690674 5.62856C0.690674 2.66535 3.09284 0.263184 6.05606 0.263184C9.01927 0.263184 11.4214 2.66535 11.4214 5.62856C11.4214 6.80819 11.0401 7.89966 10.395 8.78521C10.3656 8.82551 10.3694 8.88127 10.4047 8.91652L13.0479 11.5597C13.3408 11.8526 13.3408 12.3275 13.0479 12.6204C12.755 12.9133 12.2801 12.9133 11.9872 12.6204L9.34401 9.97718Z",
    fill: "#60636B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.b9708a89a25420ca60a95d400f7860ca.svg";
export { ForwardRef as ReactComponent };